import { Theme } from "@emotion/react";
import { PartialDeep } from "type-fest";

const theme: PartialDeep<Theme> = {};

export default theme;
